module.exports = __webpack_public_path__ + "img/VillaLoreto_Hote1l.a48c6cd5.jpg";